export enum Command {
	checkIn,
	discard,
	checkOut,
	checkOutEmpty,

	addPoint,
	discardPoint,
	deletePoint,
	deleteSelection,
	assignSelectionToProject,
	removeSelectionFromProject,
	savePoint,

	addAttachment,
	removeAttachment,

	goBack,
	goBackToPoint,

	importDirectories,
	importFiles,
	importWizard,
	export,
	exportProtocols,
	exportMapData,
	exportPdf,
	print,

	commentTools,
	commentSwitch,

	gpsHome,

	cleanUp,
}
